export const ONBOARDING_QUESTIONS = [
  {
    key: 'corps_function',
    title: 'What is your corps or work function?',
    subtitle: 'This helps us personalise your experience',
    multiSelect: false,
    options: [
      {
        value: 'combat',
        label: 'Combat',
        sublabel: 'Infantry, Armoured, Artillery, Engineers, Aviation',
      },
      { value: 'intelligence', label: 'Intelligence' },
      { value: 'signals', label: 'Signals & Communications' },
      { value: 'logistics', label: 'Logistics & Transport' },
      { value: 'medical', label: 'Medical & Dental' },
      {
        value: 'support',
        label: 'Support Services',
        sublabel: 'Legal, Chaplains, Psychology, Education',
      },
      { value: 'admin_finance', label: 'Administration & Finance' },
      { value: 'hq_command', label: 'Headquarters / Command Staff' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    key: 'primary_work',
    title: 'Which best describes your primary work?',
    subtitle: "We'll tailor prompt suggestions to your workflow",
    multiSelect: false,
    options: [
      { value: 'field_operational', label: 'Field / operational role' },
      { value: 'hq_command_staff', label: 'Headquarters or command staff' },
      { value: 'policy_planning', label: 'Policy or planning' },
      { value: 'admin_finance', label: 'Administration or finance' },
      { value: 'training_education', label: 'Training or education' },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    key: 'genai_goals',
    title: 'What are you hoping to get out of using GenAI tools?',
    subtitle: 'Select all that apply',
    multiSelect: true,
    options: [
      { value: 'save_time', label: 'Save time on written tasks' },
      { value: 'improve_quality', label: 'Improve the quality of my work' },
      { value: 'learn_ai', label: 'Learn how to use AI more effectively' },
      { value: 'automate_tasks', label: 'Automate repetitive tasks' },
      {
        value: 'analyse_summarise',
        label: 'Better analyse and summarise information',
      },
      { value: 'other', label: 'Other' },
    ],
  },
  {
    key: 'genai_tools',
    title: 'Which GenAI tools do you use at the moment?',
    subtitle: 'Select all that apply',
    multiSelect: true,
    options: [
      { value: 'copilot', label: 'Copilot' },
      { value: 'chatgpt', label: 'ChatGPT' },
      { value: 'claude', label: 'Claude' },
      { value: 'gemini', label: 'Gemini' },
      { value: 'perplexity', label: 'Perplexity' },
      { value: 'other', label: 'Other' },
    ],
  },
];
